import { useState } from 'react';

export const useTimelineFilters = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedManager, setSelectedManager] = useState(null);
    const [selectedPurpose, setSelectedPurpose] = useState(null);
    const [appliedFilters, setAppliedFilters] = useState({
        startDate: '',
        endDate: '',
        salesManagerUUID: '',
        purposeOfVisit: ''
    });

    const applyFilters = () => {
        setAppliedFilters({
            startDate: startDate,
            endDate: endDate,
            salesManagerUUID: selectedManager ? selectedManager.value : '',
            purposeOfVisit: selectedPurpose ? selectedPurpose.value : ''
        });
        return true; // Return true to indicate filters applied successfully
    };

    const clearFilters = () => {
        setStartDate('');
        setEndDate('');
        setSelectedManager(null);
        setSelectedPurpose(null);
        setAppliedFilters({
            startDate: '',
            endDate: '',
            salesManagerUUID: '',
            purposeOfVisit: ''
        });
    };

    const removeFilter = (type) => {
        let newFilters = { ...appliedFilters };
        switch(type) {
            case 'date':
                setStartDate('');
                setEndDate('');
                newFilters.startDate = '';
                newFilters.endDate = '';
                break;
            case 'manager':
                setSelectedManager(null);
                newFilters.salesManagerUUID = '';
                break;
            case 'purpose':
                setSelectedPurpose(null);
                newFilters.purposeOfVisit = '';
                break;
            default:
                break;
        }
        setAppliedFilters(newFilters);
    };

    return {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        selectedManager,
        setSelectedManager,
        selectedPurpose,
        setSelectedPurpose,
        appliedFilters,
        applyFilters,
        clearFilters,
        removeFilter
    };
};
